@if (successMessages.length > 0) {
  <div class="card-messages card-messages--success">
    <span class="card-messages__close card-messages__close--success" (click)="successMessages=[]">&times;</span>
    @for (successMessage of successMessages; track successMessage) {
      <span id="card-messages.success" data-cy="card-messages-success" class="card-messages__msg"
        >
        {{successMessage}}
      </span>
    }
  </div>
}
@if (errorMessages.length > 0) {
  <div class="card-messages card-messages--error">
    <span class="card-messages__close card-messages__close--error" (click)="errorMessages=[]">&times;</span>
    @if (errorMessages.length > 1) {
      <span id="card-messages.multiple-errors" class="card-messages__msg bold">There were
      {{errorMessages.length}} errors with your submission</span>
    }
    @for (errorMessage of errorMessages; track errorMessage) {
      <span id="card-messages.error" data-cy="card-messages-error" class="card-messages__msg"
        [ngClass]="{'card-messages__msg--list': errorMessages.length > 1}">
        {{errorMessage}}
      </span>
    }
  </div>
}
@if (warningMessages.length > 0) {
  <div class="card-messages card-messages--warning">
    <span class="card-messages__close card-messages__close--warning" (click)="warningMessages=[]">&times;</span>
    @for (warningMessage of warningMessages; track warningMessage) {
      <span id="card-messages.warning" data-cy="card-messages-warning" class="card-messages__msg"
        >
        {{warningMessage}}
      </span>
    }
  </div>
}
